'use client';

import React from 'react';
import styles from './ButtonFilled.module.css';

interface Props {
    children: React.ReactNode;
    full: boolean;
    onClick?: () => void;
    pathname?: string;
}

export const ButtonFilled = ({ children, full, pathname, onClick }: Props) => {
    return (
        <button
            onClick={onClick}
            className={[styles.button, pathname === '/calculator' ? styles.buttonOrange : ''].join(
                ' ',
            )}
            style={{ width: full ? '100%' : '' }}
        >
            {children}
        </button>
    );
};
